<ng-container *ngIf="data">
  <app-header [items]="data.menu" [showSearchField]="false"></app-header>
  <app-carousel [items]="data.carousel"></app-carousel>
  <app-cards [items]="data.main"></app-cards>
  <app-footer></app-footer>
</ng-container>
